import { render } from "./research.vue?vue&type=template&id=19886493&scoped=true"
import script from "./research.vue?vue&type=script&lang=js"
export * from "./research.vue?vue&type=script&lang=js"

import "./research.vue?vue&type=style&index=0&id=19886493&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19886493"]])

export default __exports__